import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45 }}>
      <p className="text-xs font-black text-black/30 uppercase tracking-[0.2em] mb-2">{eyebrow}</p>
      <h1
        className="text-black font-black text-3xl sm:text-4xl tracking-tight mb-2"
        style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
      >
        {title}
      </h1>
      <p className="text-black/40 text-sm mb-10">{subtitle}</p>
    </motion.div>
  );
}

export function PolicyCard({ children }) {
  return (
    <div className="rounded-2xl border border-black/8 overflow-hidden mb-10" style={{ background: "#f9fafb" }}>
      {children}
    </div>
  );
}

export function PolicyRow({ icon, iconBg, iconBorder, iconColor, title, children, last }) {
  return (
    <div className={`px-5 py-4 ${last ? "" : "border-b border-black/6"}`}>
      <div className="flex items-start gap-3">
        <span
          className="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-black flex-shrink-0 mt-0.5 border"
          style={{ background: iconBg, borderColor: iconBorder, color: iconColor }}
        >
          {icon}
        </span>
        <div>
          <p className="text-black font-semibold text-sm leading-snug">{title}</p>
          <div className="text-black/50 text-xs mt-0.5 leading-relaxed">{children}</div>
        </div>
      </div>
    </div>
  );
}

export function ContactNudge() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.25 }}
      className="mt-10 rounded-2xl border border-[#f59e0b]/30 bg-amber-50 px-6 py-5 text-center"
    >
      <p className="text-[#b45309] font-bold text-sm mb-0.5">Need help?</p>
      <p className="text-[#b45309]/60 text-xs">
        Reach us on{" "}
        <a href="https://wa.me/919133303044" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#b45309]">
          WhatsApp
        </a>{" "}
        or email{" "}
        <a href="mailto:support@townsquarearena.com" className="underline hover:text-[#b45309]">
          support@townsquarearena.com
        </a>
      </p>
    </motion.div>
  );
}

export function FAQItem({ item, index }) {
  const [open, setOpen] = useState(false);
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.04, duration: 0.35 }}
      className="border border-black/8 rounded-2xl overflow-hidden"
    >
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left hover:bg-black/[0.02] transition-colors"
      >
        <span className="text-black font-semibold text-sm leading-snug">{item.q}</span>
        <span
          className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-black transition-all ${
            open ? "bg-[#f59e0b] text-black" : "bg-black/6 text-black/40"
          }`}
        >
          {open ? "−" : "+"}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="body"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
            style={{ overflow: "hidden" }}
          >
            <p className="px-5 pb-5 pt-1 text-black/55 text-sm leading-relaxed border-t border-black/6">
              {item.a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
